<div *ngIf="currentEnvironment && currentEnvironment !== 'PROD'" class="tarja w-full text-center">
    <span class="user-name">{{ 'Você está em ambiente ' + currentEnvironment }}</span>
</div>
